import { get } from '../utils/fetch';
import { MODE_FAQ_API_ERROR } from '../defines/mode';

export const FaqApi = {
  getFaqs: async (
    serviceId: number,
    serviceAttribute: number,
    partnerId: string,
  ): Promise<FaqMessageEntity> => {
    const url = `/api/faqs/${serviceId}/${serviceAttribute}/${partnerId}`;

    // for quick test, secret 'mode' parameter is checked. when mode is expected, then it raises Exception
    // nobody knows this parameter!
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('mode') === MODE_FAQ_API_ERROR) {
      throw new Error();
    }
    return await get(url, 'getFaqs');
  },
};

// TODO: samp implementation in rmp-bff -> move to rmp-modules
export interface FaqMessageEntity {
  hotelId: number;
  hotelName: string;
  inquiryCategories: InquiryCategory[];
}

// TODO: samp implementation in rmp-bff -> move to rmp-modules
interface InquiryCategory {
  inquiryCategoryId: number;
  inquiryCategory: string;
  inquirySubCategories: Faq[];
}

// TODO: samp implementation in rmp-bff -> move to rmp-modules
interface Faq {
  inquirySubCategoryId: number;
  inquirySubCategory: string;
  answer: string;
}
